<template>
  <div class="mb-3 overflow-auto max-h-52 min-h-40">
    <div
      :class="[
        presentation.id === selectedPresentationId
          ? 'presentation-item--active'
          : 'presentation-item'
      ]"
      :key="presentation.id"
      @click="handlePresentationItemClick(presentation)"
      v-for="(presentation) in mostRecentPresentations"
    >
      <input
        class="mr-2 cursor-pointer"
        type="radio"
        :checked="presentation.id === selectedPresentationId"
      >
      <span class="truncate">{{ presentation.name }}</span>
      <span class="ml-1 text-base-70">({{ presentation.accessCode }})</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedPresentationId: {
      type: Number,
      default: null,
    },
    mostRecentPresentations: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handlePresentationItemClick(presentation) {
      this.$emit('handlePresentationItemClick', presentation)
    },
  },
}
</script>

<style lang="scss" scoped>
.presentation-item,
.presentation-item--active {
  padding: 0.5rem 0.75rem 0.5rem 0.5rem;
  margin-left: 1rem;
  cursor: pointer;
  transition: 250ms all ease-in-out;
  display: flex;
  align-items: center;
}
.presentation-item--active {
  background-color: rgb(231, 232, 235);
}
.presentation-item:hover {
  background-color: rgba(231, 232, 235, 0.5);
}
</style>
